function SortHeader(props) {
  const {
    setAscending,
    setShowContributionsWithPhotos,
    isUserLoggedIn,
    profilePage
  } = props;

  const handleSelectChange = e => {
    e.target?.value !== "" && setAscending(e.target.value === 'oldest-first')
  }

  const handleCheckboxChange = e => {
    setShowContributionsWithPhotos(e.target.checked);
  }

  return (
    <div className={`ugc-comments-list__sort-filter-options ${profilePage
      ? 'ugc-comments-list__sort-filter-options--profile-page' : isUserLoggedIn
       ? 'ugc-comments-list__sort-filter-options--user-logged-in' : 'ugc-comments-list__sort-filter-options--default'}`}>
      <div className="checkbox-container">
        <input type="checkbox" id="only-show-photos" className="form-field checkbox-field" name="only-show-photos"
          onChange={handleCheckboxChange} />
        <label className="form-label ugc-comments-list__only-show-photos" htmlFor="only-show-photos">
          Only show contributions with photos
        </label>
      </div>
      <label className="ugc-comments-list__sort-by-date" htmlFor="sort-by-date">
        Sort by
      </label>
      <div className=" dropdown-container ugc-comments-list__dropdown-container">
        <select className="dropdown-field ugc-comments-list__dropdown-sort-by-date" name="sort-by-date"
          id="sort-by-date" onChange={handleSelectChange}>
          <option value="newest-first">Newest to oldest</option>
          <option value="oldest-first">Oldest to newest</option>
        </select>
      </div>
    </div>
  );
}

export default SortHeader;
